import React from 'react'

const Youtube = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
    >
      <g>
        <g>
          <path
            className="outer-path"
            fill="#939393"
            d="M15.5 31C24.06 31 31 24.06 31 15.5 31 6.94 24.06 0 15.5 0 6.94 0 0 6.94 0 15.5 0 24.06 6.94 31 15.5 31z"
          />
        </g>
        <g>
          <path
            fill="#fff"
            d="M12.993 20.493v-9.4l7.11 4.7zm13.393-9.013c0-1.79-1.456-3.24-3.253-3.24H7.873a3.246 3.246 0 0 0-3.253 3.24v8.69c0 1.79 1.456 3.24 3.252 3.24h15.26a3.246 3.246 0 0 0 3.254-3.24v-8.69z"
          />
        </g>
      </g>
    </svg>
  )
}

export default Youtube
